// Copyright (c) 2022 by Move Closer

import { MappingConfig } from '@movecloser/front-core'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const attributesAdapterMap: MappingConfig = {
  additionalDescription: 'additional_description',
  aromaticNote: 'aromatic_note',
  brand: 'brand',
  colorName: 'color_name',
  composition: 'composition',
  consistency: 'consistency',
  extendedDescription: 'extended_description',
  forWhom: 'for_whom',
  isFaF: 'isFaF',
  isNatural: 'isNatural',
  isNew: 'isNew',
  isSale: 'isSale',
  kindOfProduct: 'kind_of_product',
  loyaltyPrograms: 'loyalty_programs',
  mainCategory: 'main_category',
  mainCategoryUrl: 'main_category_url',
  mainDescription: 'main_description',
  operation: 'operation',
  priceRange: 'price_range',
  producer: 'producer',
  skinType: 'skin_type',
  snippetId: 'snippetId',
  spfFilter: 'spf_filter',
  taxClassId: 'tax_class_id',
  variantVolume: 'variant_volume',
  volumeName: 'volume_name',
  volume: 'volume',
  weightName: 'weight_name'
}
